
// 数据字典定义
export const registerText = {
  0: '',
  1: '手机号码有误',
  2: '系统异常',
  3: '两次密码输入不一致',
  4: '手机号码已存在',
  5: '验证码为空',
  6: '验证码错误或失效'
}

export const validatePhoneText = {
  1: '用户已存在',
  2: '系统异常',
  3: '手机号不正确'
}
export const strengthen = (n) =>{
  let json = {
    0:['',6,7,8,9,10,11,12,13,14,15],
    1:['',6,7,8,9,10,11,12,13,14,15],
    2:['',6,7,8,9,10,11,12,13,14,15],
    3:['',1,2,3,4,5,6,7,8,9,10]
  }
  return json[n]
}

export const icons = {
  0:'武',
  1:'防',
  2:'甲',
  3:'饰',
  4:'披',
  5:'宠',
  6:'武',
  7:'武',
  20:'号'
}
export const type = (n) =>{
  let json = {
    0:['','刀','枪','剑','弓','医','刺客','乐师','韩飞官','谭花灵','格斗家','梅柳真','卢风郎','东陵神女'],
    1:['无','刀','枪','剑','弓','医','刺客','乐师','韩飞官','谭花灵','格斗家','梅柳真','卢风郎','东陵神女'],
    2:[],
    3:['耳环','戒指','项链'],
    4:['男','女'],
    5:['龙猫','霸天虎','追风豹','雪翼雕','粉狼','银狼','金狼','蓝狼','松狮犬','杜宾犬'],
    20:['','刀','枪','剑','弓','医','刺客','乐师','韩飞官','谭花灵','格斗家','梅柳真','卢风郎','东陵神女'],
  }
  return json[n]
}
export const kinds = (n) =>{
  let json = {
    0:['武器','衣服/手脚','内甲','首饰','披风','灵兽'],
    1:['上二','下三','首饰','披风/门甲'],
  }
  return json[n]
}

export const level=(n)=>{
  let json = {
    0:[1,10,35,60,80,100,110,120,130,140,150],
    1:[10,20,30,40,50,60,70,80,90,100,110,120,130,140,150],
    2:[15,25,35,45,55,65,75,85,95,105,115,125,135,145],
    3:[60,80,100,110,115,120,130,140,150]
  };
  return json[n]
}
export const compose=(n)=>{
  let json = [];
  if(n == 5){
    json = [
      '',
      '满属性',
      '其他',
    ]
  }
  if(n == 4){
    json = [
      '',
      '物品 升级 成功 概率 1% 增加 * 4',
      '货币 获得量 10% 增加 * 4',
      '狂风万破 * 4',
      '真武绝技 * 4',
      '乾坤挪移 * 4',
      '回柳身法 * 4',
      '怒海狂澜 * 4',
      '心神凝聚 * 4',
      '九天真气 * 4',
      '长功击力 * 4',
      '霸气破甲 * 4',
      '稳如泰山 * 4',
      '百变神行 * 4',
      '愤怒爆发 * 4',
      '剑刃乱舞 * 4',
      '障力恢复 * 4',
      '荆轲之怒 * 4',
      '《岳阳三醉》 * 4'
    ]
  }
  if(n == 2){
    json = [
      '',
      '防御力 增加 7 * 2',
      '防御力 增加 8 * 2',
      '防御力 增加 9 * 2',
      '防御力 增加 10 * 2',
      '防御力 增加 11 * 2',
      '防御力 增加 13 * 2',
      '防御力 增加 14 * 2',
      '防御力 增加 15 * 2',
      '武功 防御力 增加 40 * 2',
      '武功 防御力 增加 80 * 2',
      '武功 防御力 增加 85 * 2',
      '武功 防御力 增加 90 * 2',
      '武功 防御力 增加 95 * 2',
      '武功 防御力 增加 100 * 2',
      '生命力 增加 50 * 2',
      '生命力 增加 80 * 2',
      '生命力 增加 100 * 2',
      '回避率 增加 100 * 2'
    ]
  }
  if(n == 1){
    json = [
      '',
      '防御力 增加 7 * 4',
      '防御力 增加 8 * 4',
      '防御力 增加 9 * 4',
      '防御力 增加 10 * 4',
      '防御力 增加 11 * 4',
      '防御力 增加 13 * 4',
      '防御力 增加 14 * 4',
      '防御力 增加 15 * 4',
      '武功 防御力 增加 40 * 4',
      '武功 防御力 增加 80 * 4',
      '武功 防御力 增加 85 * 4',
      '武功 防御力 增加 90 * 4',
      '武功 防御力 增加 95 * 4',
      '武功 防御力 增加 100 * 4',
      '生命力 增加 50 * 4',
      '生命力 增加 80 * 4',
      '生命力 增加 100 * 4',
      '回避率 增加 100 * 4'
    ]
  }
  if(n == 0){
    json = [
      '',
      '全部 气功 等级 增加 1 * 4',
      '全部 气功 等级 增加 2 * 4',
      '武功 攻击力 增加 24 * 4',
      '武功 攻击力 增加 25 * 4',
      '武功 攻击力 增加 29 * 4',
      '武功 攻击力 增加 30 * 4',
      '武功 攻击力 增加 31 * 4',
      '武功 攻击力 增加 33 * 4',
      '武功 攻击力 增加 34 * 4',
      '武功 攻击力 增加 35 * 4',
      '武功 攻击力 增加 40 * 4',
      '攻击力 增加 14 * 4',
      '攻击力 增加 15 * 4',
      '攻击力 增加 20 * 4',
      '攻击力 增加 30 * 4',
    ]
  }
  return json
}
export const Dictionaries=(n,k,j)=>{
  let json = {
    0:{
      1: {
        1: ['直刀', '铁刀'],
        10: ['赤血刀', '重曲刀'],
        35: ['破仙刀', '青龙刀', '城碧刀', '深渊刀'],
        60: ['血吟刀', '渤海刀'],
        80: ['金刚破天斩', '紫金盘龙刀'],
        100: ['戮神', '屠龙'],
        110: ['斩月刀', '龙息刀'],
        120: ['鬼影狂刀', '帝皇战刀'],
        130: ['泣血殇', '鳌天斩', '真-泣血殇', '真-鳌天斩'],
        140: ['月光血刀', '月光圣刀', '真-月光血刀', '真-月光圣刀'],
        150: ['真武血刀', '真武圣刀', '真-真武血刀', '真-真武圣刀'],
      },
      2: {
        1: ['木枪', '长枪'],
        10: ['天焰枪', '飞龙枪'],
        35: ['噬魄枪', '七星枪', '玄冥枪', '益宣枪'],
        60: ['灭世断魂枪', '磐龙破魔枪'],
        80: ['天魔神枪', '天人神枪'],
        100: ['五毒透龙枪', '一丈威'],
        110: ['刑天枪', '破胆枪'],
        120: ['毁天灭地枪', '青龙掠影枪'],
        130: ['燃血亡戬', '擎天圣戟', '真-燃血亡戬', '真-擎天圣戟'],
        140: ['月光血枪', '月光神枪', '真-月光血枪', '真-月光神枪'],
        150: ['真武血戟', '真武圣戟', '真-真武血戟', '真-真武圣戟'],

      },
      3: {
        1: ['木剑', '铁剑'],
        10: ['青峰剑', '金月剑'],
        35: ['血魔剑', '寒月剑', '血河剑', '青魄剑'],
        60: ['逐日追风剑', '天地剑'],
        80: ['惟尊剑', '霸王之剑'],
        100: ['轩辕', '诛仙','金蛇'],
        110: ['承影剑', '长生剑'],
        120: ['诛神魔舞剑', '灭魂斩魔剑'],
        130: ['天罡沁血', '浪天厥', '真-天罡沁血', '真-浪天厥'],
        140: ['月光血剑', '月光神剑', '真-月光血剑', '真-月光神剑'],
        150: ['真武血剑', '真武圣剑', '真-真武血剑', '真-真武圣剑'],
      },
      4: {
        1: ['竹弓', '硬弓'],
        10: ['六合弓', '天羽弓'],
        35: ['天狼弓', '圣者弓', '魔音弓', '神臂弓'],
        60: ['冥魂魔弓', '九天神弓'],
        80: ['诛神魔弓', '羿王神弓'],
        100: ['冥王魔弓', '腾龙神弓'],
        110: ['落日弓', '凤鸣弓'],
        120: ['裂天射月弓', '龙啸穿云弓'],
        130: ['烈血残阳', '丹霞碧天', '真-烈血残阳', '真-丹霞碧天'],
        140: ['月光血弓', '月光神弓', '真-月光血弓', '真-月光神弓'],
        150: ['真武血弓', '真武圣弓', '真-真武血弓', '真-真武圣弓'],
      },
      5: {
        1: ['木杖', '桃木杖'],
        10: ['太乙杖', '百花杖'],
        35: ['鬼泣杖', '火欲杖', '赤魔杖', '龙骨杖'],
        60: ['蚀天魔杖', '圣天神杖'],
        80: ['无极魔杖', '太乙神杖'],
        100: ['无天魔杖', '降魔神杖'],
        110: ['风雷扇', '流光扇'],
        120: ['掠影惊雷扇', '神木帝芒扇'],
        130: ['燎风落血', '天罗抚雨', '真-燎风落血', '真-天罗抚雨'],
        140: ['月光血扇', '月光圣扇', '真-月光血扇', '真-月光圣扇'],
        150: ['真武血扇', '真武圣扇', '真-真武血扇', '真-真武圣扇'],
      },
      6: {
        1: ['短刃', '白刃'],
        10: ['刺刃', '灵刃'],
        35: ['亡魂刃', '飞烟刃', '魔袭之刃', '金焱之刃'],
        60: ['精魂邪刃', '紫薇侠刃'],
        80: ['修罗降鬼刃', '冰旋寒霜刃'],
        100: ['魔龙斩魂刃', '究雷戮魔刃'],
        110: ['陨星刃', '迅雷刃'],
        120: ['无光利刃', '龙牙之刃'],
        130: ['血信子', '天灵子', '真-血信子', '真-天灵子'],
        140: ['月光血刃', '月光圣刃', '真-月光血刃', '真-月光圣刃'],
        150: ['真武血飞刃', '真武圣刃', '真-真武血飞刃', '真-真武圣刃'],
      },
      7: {
        1: ['无名玄琴'],
        10: ['清水玄琴'],
        35: ['赤叶玄琴', '清竹玄琴'],
        60: ['赤月炫琴', '清月玄琴'],
        80: ['鹤鸣秋月琴', '舞风紫云琴'],
        100: ['墨夜展华琴', '逍遥琉天琴'],
        110: ['红颜吻泪琴', '虎啸龙吟琴'],
        120: ['海月清辉琴', '梅花落雪琴'],
        130: ['九绝七玄琴', '九霄环佩琴', '真-九绝七玄琴', '真-九霄环佩琴'],
        140: ['月光血琴', '月光宝琴', '真-月光血琴', '真-月光宝琴'],
        150: ['真武血琴', '真武圣琴', '真-真武血琴', '真-真武圣琴'],
      },
      8: {
        1: ['白龙刀(封印)'],
        10: ['白龙刀(一转)'],
        35: ['白龙刀(二转)'],
        60: ['白龙刀(三转)'],
        80: ['白龙刀(四转)'],
        100: ['白龙刀(五转)'],
        110: ['白龙刀(五转以上)'],
        120: ['白龙刀(升天二)'],
        130: ['白龙刀(升天三)', '火龙刀', '真-白龙刀(升天三)'],
        140: ['白龙刀(升天四)', '真-白龙刀(升天四)'],
        150: ['白龙刀（升天五）', '真-白龙刀（升天五）'],
      },
      9: {
        1: ['黑灵剑(封印)'],
        10: ['黑灵剑(一转)'],
        35: ['黑灵剑(二转)'],
        60: ['黑灵剑(三转)'],
        80: ['黑灵剑(四转)'],
        100: ['黑灵剑(五转)'],
        110: ['黑灵剑(五转以上)'],
        120: ['黑灵剑(升天二)'],
        130: ['黑灵剑(升天三)'],
        140: ['黑灵剑(升天四)', '真-黑灵剑(升天四)'],
        150: ['黑灵剑（升天五）', '真-黑灵剑（升天五）'],
      },
      10: {
        1: ['黑皮拳套'],
        10: ['玄铁拳套'],
        35: ['碧影拳套', '赤风拳套'],
        60: ['浴火拳套', '慑天拳套'],
        80: ['魅天拳套', '水月拳套'],
        100: ['百炼赤虎拳', '炎煌青虎拳'],
        110: ['冥炎赤狼拳', '青麟青狼拳'],
        120: ['青蛊鬼影拳', '昱暝帝皇拳'],
        130: ['炎狱拳', '天弈拳', '真-天弈拳', '真-炎狱拳'],
        140: ['月光血拳', '月光神拳', '真-月光血拳', '真-月光神拳'],
        150: ['真武血拳', '真-真武血拳'],
      },
      11: {
        1: ['赤龙弓（封印）'],
        10: ['赤龙弓（1转）'],
        35: ['赤龙弓（2转）'],
        60: ['赤龙弓（3转）'],
        80: ['赤龙弓（4转）', '玄武破天弓（4转）'],
        100: ['赤龙弓（5转）', '玄武破天弓（5转）'],
        110: ['赤龙弓（5转以上）'],
        120: ['赤龙弓（升天二）'],
        130: ['赤龙弓（升天三）', '真-赤龙弓（升天三）'],
        140: ['赤龙弓（升天四）', '真-赤龙弓（升天四）', '真-玄武破天弓（升天四）'],
        150: ['赤龙弓(升天五)', '真-赤龙弓(升天五)'],
      },
      12: {
        1: ['苛天戟(封印)'],
        10: ['苛天戟(1转)'],
        35: ['苛天戟(2转)'],
        60: ['苛天戟(3转)'],
        80: ['苛天戟(4转)'],
        100: ['苛天戟(5转)'],
        110: ['苛天戟(5转以上)', '追魂五星枪（升天一）'],
        120: ['苛天戟(升天二)'],
        130: ['苛天戟(升天三)', '真-苛天戟(升天三)'],
        140: ['苛天戟(升天四)', '真-苛天戟(升天四)'],
        150: ['苛天戟(升天五)', '真-苛天戟(升天五)'],
      },
      13: {
        1: ['寒玉神杖(封印)'],
        10: ['寒玉神杖(1转)'],
        35: ['寒玉神杖(2转)'],
        60: ['寒玉神杖(3转)'],
        80: ['寒玉神杖(4转)'],
        100: ['寒玉神杖(5转)'],
        110: ['寒玉神杖(5转以上)'],
        120: ['寒玉神杖(升天二)'],
        130: ['寒玉神杖(升天三)', '真-寒玉神杖(升天三)'],
        140: ['寒玉神杖(升天四)', '真-寒玉神杖(升天四)'],
        150: ['寒玉神杖(升天五)', '真-寒玉神杖(升天五)'],
      }
    },
    1:{
      0: {
        10: ['皮短靴', '青铜护手'],
        20: ['无名长靴', '精炼护手'],
        30: ['皮长靴', '罗汉护手'],
        40: ['龙虎长靴', '龙虎护手', '破天长靴', '破天护手'],
        50: ['封神长靴', '封神护手', '赤龙长靴', '赤龙护手'],
        60: ['昊天长靴', '昊天护手', '雪天长靴', '雪天护手'],
        70: ['御风神靴', '追月护手', '地藏冥靴', '凌鹰护手'],
        80: ['月神长靴', '月神护手', '凝血长靴', '凝血护手'],
        90: ['天灵长靴', '天灵护手', '魔灵长靴', '魔灵护手'],
        100: ['龙腾长靴', '龙腾护手', '炎魔长靴', '炎魔护手'],
        110: ['天授战靴', '天授护手', '焚天战靴', '焚天护手'],
        120: ['天尊战靴', '天尊护手', '邪尊战靴', '邪尊护手'],
        130: ['天元战靴', '天元护手', '真-天元战靴', '真-天元护手', '邪元战靴', '邪元护手', '真-邪元战靴', '真-邪元护手'],
        140: ['轩舞长靴', '轩舞护手', '真-轩舞长靴', '真-轩舞护手', '赤夜长靴', '赤夜护手', '真-赤夜长靴', '真-赤夜护手'],
        150: ['浩天靴子', '浩天护手', '真-浩天靴子', '真-浩天护手', '魔渊靴子', '魔渊护手', '真-魔渊靴子', '真-魔渊护手'],
      },
      1: {
        10: ['无名战袍(男)', '无名战袍(女)'],
        20: ['金丝战袍(男)', '金丝战袍(女)'],
        30: ['乌蚕战袍(男)', '乌蚕战袍(女)'],
        40: ['龙虎战袍(男)', '龙虎战袍(女)', '破天战袍(男)', '破天战袍(女)'],
        50: ['封神战袍(男)', '封神战袍(女)', '赤龙战袍(男)', '赤龙战袍(女)'],
        60: ['昊天战袍(男)', '昊天战袍(女)', '雪天战袍(男)', ' 雪天战袍(女)'],
        70: ['广寒战袍(男)', '广寒战袍(女)', '地藏战袍(男)', '地藏战袍(女)'],
        80: ['月神战袍(男)', '月神战袍(女)', '凝血战袍(男)', '凝血战袍(女)'],
        90: ['天灵战袍(男)', '天灵战袍(女)', '魔灵战袍(男)', '魔灵战袍(女)'],
        100: ['龙腾战袍(男)', '龙腾战袍(女)', '炎魔战袍(男)', '炎魔战袍(女)'],
        110: ['天授战袍(男)', '天授战袍(女)', '焚天战袍(男)', '焚天战袍(女)'],
        120: ['天尊龙铠(男)', '天尊龙铠(女)', '邪尊龙铠(男)', '邪尊龙铠(女)'],
        130: ['天元龙铠(男)', '天元龙铠(女)', '真-天元龙铠(男)', '真-天元龙铠(女)', '邪元龙铠(男)', '邪元龙铠(女)', '真-邪元龙铠(男)', '真-邪元龙铠(女)'],
        140: ['轩舞龙铠(男)', '轩舞龙铠(女)', '真-轩舞龙铠(男)', '真-轩舞龙铠(女)', '赤夜龙铠(男)', '赤夜龙铠(女)', '真-赤夜龙铠(男)', '真-赤夜龙铠(女)'],
        150: ['浩天战袍(男)', '浩天战袍(女)', '真-浩天战袍(男)', '真-浩天战袍(女)', '魔渊战袍(男)', '魔渊战袍(女)', '真-魔渊战袍(男)', '真-魔渊战袍(女)'],
      },
      2: {
        10: ['无名枪衣(男)', '无名枪衣(女)'],
        20: ['金丝枪衣(男)', '金丝枪衣(女)'],
        30: ['乌蚕枪衣(男)', '乌蚕枪衣(女)'],
        40: ['龙虎枪衣(男)', '龙虎枪衣(女)', '破天枪衣(男)', '破天枪衣(女)'],
        50: ['封神枪衣(男)', '封神枪衣(女)', '赤龙枪衣(男)', '赤龙枪衣(女)'],
        60: ['昊天枪衣(男)', '昊天枪衣(女)', '雪天枪衣(男)', ' 雪天枪衣(女)'],
        70: ['广寒枪衣(男)', '广寒枪衣(女)', '地藏枪衣(男)', '地藏枪衣(女)'],
        80: ['月神枪衣(男)', '月神枪衣(女)', '凝血枪衣(男)', '凝血枪衣(女)'],
        90: ['天灵枪衣(男)', '天灵枪衣(女)', '魔灵枪衣(男)', '魔灵枪衣(女)'],
        100: ['龙腾枪衣(男)', '龙腾枪衣(女)', '炎魔枪衣(男)', '炎魔枪衣(女)'],
        110: ['天授枪衣(男)', '天授枪衣(女)', '焚天枪衣(男)', '焚天枪衣(女)'],
        120: ['天尊霸铠(男)', '天尊霸铠(女)', '邪尊霸铠(男)', '邪尊霸铠(女)'],
        130: ['天元霸铠(男)', '天元霸铠(女)', '真-天元霸铠(男)', '真-天元霸铠(女)', '邪元霸铠(男)', '邪元霸铠(女)', '真-邪元霸铠(男)', '真-邪元霸铠(女)'],
        140: ['轩舞霸铠(男)', '轩舞霸铠(女)', '真-轩舞霸铠(男)', '真-轩舞霸铠(女)', '赤夜霸铠(男)', '赤夜霸铠(女)', '真-赤夜霸铠(男)', '真-赤夜霸铠(女)'],
        150: ['浩天枪衣(男)', '浩天枪衣(女)', '真-浩天枪衣(男)', '真-浩天枪衣(女)', '魔渊枪衣(男)', '魔渊枪衣(女)', '真-魔渊枪衣(男)', '真-魔渊枪衣(女)'],
      },
      3: {
        10: ['无名侠衣(男)', '无名侠衣(女)'],
        20: ['金丝侠衣(男)', '金丝侠衣(女)'],
        30: ['乌蚕侠衣(男)', '乌蚕侠衣(女)'],
        40: ['龙虎侠衣(男)', '龙虎侠衣(女)', '破天侠衣(男)', '破天侠衣(女)'],
        50: ['封神侠衣(男)', '封神侠衣(女)', '赤龙侠衣(男)', '赤龙侠衣(女)'],
        60: ['昊天侠衣(男)', '昊天侠衣(女)', '雪天侠衣(男)', ' 雪天侠衣(女)'],
        70: ['广寒侠衣(男)', '广寒侠衣(女)', '地藏侠衣(男)', '地藏侠衣(女)'],
        80: ['月神侠衣(男)', '月神侠衣(女)', '凝血侠衣(男)', '凝血侠衣(女)'],
        90: ['天灵侠衣(男)', '天灵侠衣(女)', '魔灵侠衣(男)', '魔灵侠衣(女)'],
        100: ['龙腾侠衣(男)', '龙腾侠衣(女)', '炎魔侠衣(男)', '炎魔侠衣(女)'],
        110: ['天授侠衣(男)', '天授侠衣(女)', '焚天侠衣(男)', '焚天侠衣(女)'],
        120: ['天尊帝胄(男)', '天尊帝胄(女)', '邪尊帝胄(男)', '邪尊帝胄(女)'],
        130: ['天元帝胄(男)', '天元帝胄(女)', '真-天元帝胄(男)', '真-天元帝胄(女)', '邪元帝胄(男)', '邪元帝胄(女)', '真-邪元帝胄(男)', '真-邪元帝胄(女)'],
        140: ['轩舞帝胄(男)', '轩舞帝胄(女)', '真-轩舞帝胄(男)', '真-轩舞帝胄(女)', '赤夜帝胄(男)', '赤夜帝胄(女)', '真-赤夜帝胄(男)', '真-赤夜帝胄(女)'],
        150: ['浩天侠衣(男)', '浩天侠衣(女)', '真-浩天侠衣(男)', '真-浩天侠衣(女)', '魔渊侠衣(男)', '魔渊侠衣(女)', '真-魔渊侠衣(男)', '真-魔渊侠衣(女)'],
      },
      4: {
        10: ['无名战衣(男)', '无名战衣(女)'],
        20: ['金丝战衣(男)', '金丝战衣(女)'],
        30: ['乌蚕战衣(男)', '乌蚕战衣(女)'],
        40: ['龙虎战衣(男)', '龙虎战衣(女)', '破天战衣(男)', '破天战衣(女)'],
        50: ['封神战衣(男)', '封神战衣(女)', '赤龙战衣(男)', '赤龙战衣(女)'],
        60: ['昊天战衣(男)', '昊天战衣(女)', '雪天战衣(男)', ' 雪天战衣(女)'],
        70: ['广寒战衣(男)', '广寒战衣(女)', '地藏战衣(男)', '地藏战衣(女)'],
        80: ['月神战衣(男)', '月神战衣(女)', '凝血战衣(男)', '凝血战衣(女)'],
        90: ['天灵战衣(男)', '天灵战衣(女)', '魔灵战衣(男)', '魔灵战衣(女)'],
        100: ['龙腾战衣(男)', '龙腾战衣(女)', '炎魔战衣(男)', '炎魔战衣(女)'],
        110: ['天授战衣(男)', '天授战衣(女)', '焚天战衣(男)', '焚天战衣(女)'],
        120: ['天尊御甲(男)', '天尊御甲(女)', '邪尊御甲(男)', '邪尊御甲(女)'],
        130: ['天元御甲(男)', '天元御甲(女)', '真-天元御甲(男)', '真-天元御甲(女)', '邪元御甲(男)', '邪元御甲(女)', '真-邪元御甲(男)', '真-邪元御甲(女)'],
        140: ['轩舞御甲(男)', '轩舞御甲(女)', '真-轩舞御甲(男)', '真-轩舞御甲(女)', '赤夜御甲(男)', '赤夜御甲(女)', '真-赤夜御甲(男)', '真-赤夜御甲(女)'],
        150: ['浩天战衣(男)', '浩天战衣(女)', '真-浩天战衣(男)', '真-浩天战衣(女)', '魔渊战衣(男)', '魔渊战衣(女)', '真-魔渊战衣(男)', '真-魔渊战衣(女)'],
      },
      5: {
        10: ['无名法袍(男)', '无名法袍(女)'],
        20: ['金丝法袍(男)', '金丝法袍(女)'],
        30: ['乌蚕法袍(男)', '乌蚕法袍(女)'],
        40: ['龙虎法袍(男)', '龙虎法袍(女)', '破天法袍(男)', '破天法袍(女)'],
        50: ['封神法袍(男)', '封神法袍(女)', '赤龙法袍(男)', '赤龙法袍(女)'],
        60: ['昊天法袍(男)', '昊天法袍(女)', '雪天法袍(男)', ' 雪天法袍(女)'],
        70: ['广寒法袍(男)', '广寒法袍(女)', '地藏法袍(男)', '地藏法袍(女)'],
        80: ['月神法袍(男)', '月神法袍(女)', '凝血法袍(男)', '凝血法袍(女)'],
        90: ['天灵法袍(男)', '天灵法袍(女)', '魔灵法袍(男)', '魔灵法袍(女)'],
        100: ['龙腾法袍(男)', '龙腾法袍(女)', '炎魔法袍(男)', '炎魔法袍(女)'],
        110: ['天授法袍(男)', '天授法袍(女)', '焚天法袍(男)', '焚天法袍(女)'],
        120: ['天尊仙袍(男)', '天尊仙袍(女)', '邪尊仙袍(男)', '邪尊仙袍(女)'],
        130: ['天元仙袍(男)', '天元仙袍(女)', '真-天元仙袍(男)', '真-天元仙袍(女)', '邪元仙袍(男)', '邪元仙袍(女)', '真-邪元仙袍(男)', '真-邪元仙袍(女)'],
        140: ['轩舞仙袍(男)', '轩舞仙袍(女)', '真-轩舞仙袍(男)', '真-轩舞仙袍(女)', '赤夜仙袍(男)', '赤夜仙袍(女)', '真-赤夜仙袍(男)', '真-赤夜仙袍(女)'],
        150: ['浩天法袍(男)', '浩天法袍(女)', '真-浩天法袍(男)', '真-浩天法袍(女)', '魔渊法袍(男)', '魔渊法袍(女)', '真-魔渊法袍(男)', '真-魔渊法袍(女)'],
      },
      6: {
        10: ['无名戎装(男)', '无名戎装(女)'],
        20: ['金丝戎装(男)', '金丝戎装(女)'],
        30: ['乌蚕戎装(男)', '乌蚕戎装(女)'],
        40: ['龙虎戎装(男)', '龙虎戎装(女)', '破天戎装(男)', '破天戎装(女)'],
        50: ['封神戎装(男)', '封神戎装(女)', '赤龙戎装(男)', '赤龙戎装(女)'],
        60: ['昊天戎装(男)', '昊天戎装(女)', '雪天戎装(男)', ' 雪天戎装(女)'],
        70: ['广寒戎装(男)', '广寒戎装(女)', '地藏戎装(男)', '地藏戎装(女)'],
        80: ['月神戎装(男)', '月神戎装(女)', '凝血戎装(男)', '凝血戎装(女)'],
        90: ['天灵戎装(男)', '天灵戎装(女)', '魔灵戎装(男)', '魔灵戎装(女)'],
        100: ['龙腾戎装(男)', '龙腾戎装(女)', '炎魔戎装(男)', '炎魔戎装(女)'],
        110: ['天授戎装(男)', '天授戎装(女)', '焚天戎装(男)', '焚天戎装(女)'],
        120: ['天尊戎甲(男)', '天尊戎甲(女)', '邪尊戎甲(男)', '邪尊戎甲(女)'],
        130: ['天元戎甲(男)', '天元戎甲(女)', '真-天元戎甲(男)', '真-天元戎甲(女)', '邪元戎甲(男)', '邪元戎甲(女)', '真-邪元戎甲(男)', '真-邪元戎甲(女)'],
        140: ['轩舞戎甲(男)', '轩舞戎甲(女)', '真-轩舞戎甲(男)', '真-轩舞戎甲(女)', '赤夜戎甲(男)', '赤夜戎甲(女)', '真-赤夜戎甲(男)', '真-赤夜戎甲(女)'],
        150: ['浩天戎装(男)', '浩天戎装(女)', '真-浩天戎装(男)', '真-浩天戎装(女)', '魔渊戎装(男)', '魔渊戎装(女)', '真-魔渊戎装(男)', '真-魔渊戎装(女)'],
      },
      7: {
        10: ['无名乐服(男)', '无名乐服(女)'],
        20: ['金丝乐服(男)', '金丝乐服(女)'],
        30: ['乌蚕乐服(男)', '乌蚕乐服(女)'],
        40: ['龙虎乐服(男)', '龙虎乐服(女)', '破天乐服(男)', '破天乐服(女)'],
        50: ['封神乐服(男)', '封神乐服(女)', '赤龙乐服(男)', '赤龙乐服(女)'],
        60: ['昊天乐服(男)', '昊天乐服(女)', '雪天乐服(男)', ' 雪天乐服(女)'],
        70: ['广寒乐服(男)', '广寒乐服(女)', '地藏乐服(男)', '地藏乐服(女)'],
        80: ['月神乐服(男)', '月神乐服(女)', '凝血乐服(男)', '凝血乐服(女)'],
        90: ['天灵乐服(男)', '天灵乐服(女)', '魔灵乐服(男)', '魔灵乐服(女)'],
        100: ['龙腾乐服(男)', '龙腾乐服(女)', '炎魔乐服(男)', '炎魔乐服(女)'],
        110: ['天授乐服(男)', '天授乐服(女)', '焚天乐服(男)', '焚天乐服(女)'],
        120: ['天尊乐裳(男)', '天尊乐裳(女)', '邪尊乐裳(男)', '邪尊乐裳(女)'],
        130: ['天元乐裳(男)', '天元乐裳(女)', '真-天元乐裳(男)', '真-天元乐裳(女)', '邪元乐裳(男)', '邪元乐裳(女)', '真-邪元乐裳(男)', '真-邪元乐裳(女)'],
        140: ['轩舞乐裳(男)', '轩舞乐裳(女)', '真-轩舞乐裳(男)', '真-轩舞乐裳(女)', '赤夜乐裳(男)', '赤夜乐裳(女)', '真-赤夜乐裳(男)', '真-赤夜乐裳(女)'],
        150: ['浩天乐服(男)', '浩天乐服(女)', '真-浩天乐服(男)', '真-浩天乐服(女)', '魔渊乐服(男)', '魔渊乐服(女)', '真-魔渊乐服(男)', '真-魔渊乐服(女)'],
      },
      8: {
        10: ['金丝火龙袍(男)', '金丝火龙袍(女)'],
        20: [''],
        30: ['乌蚕火龙袍(男)', '乌蚕火龙袍(女)'],
        40: [''],
        50: [''],
        60: ['云天火龙袍(男)', '云天火龙袍(男)'],
        70: [''],
        80: ['凝神火龙袍(男)', '凝神火龙袍(女)'],
        90: [''],
        100: ['腾舞火龙袍(男)', '腾舞火龙袍(女)'],
        110: ['擎天火龙袍(男)', '擎天火龙袍(女)'],
        120: ['玄尊火龙袍(男)', '玄尊火龙袍(女)'],
        130: ['上元火龙袍(男)', '上元火龙袍(女)', '真-上元火龙袍(男)', '真-上元火龙袍(女)'],
        140: ['月舞火龙袍(男)', '月舞火龙袍(女)', '真-月舞火龙袍(男)', '真-月舞火龙袍(女)'],
        150: ['浩天火龙袍(男)', '浩天火龙袍(女)', '真-浩天火龙袍(男)', '真-浩天火龙袍(女)'],
      },
      9: {
        10: ['金丝花灵衣(男)', '金丝花灵衣(女)'],
        20: [''],
        30: ['乌蚕花灵衣(男)', '乌蚕花灵衣(女)'],
        40: [''],
        50: [''],
        60: ['云天花灵衣(男)', '云天花灵衣(男)'],
        70: [''],
        80: ['凝神花灵衣(男)', '凝神花灵衣(女)'],
        90: [''],
        100: ['腾舞花灵衣(男)', '腾舞花灵衣(女)'],
        110: ['擎天花灵衣(男)', '擎天花灵衣(女)'],
        120: ['玄尊花灵衣(男)', '玄尊花灵衣(女)'],
        130: ['上元花灵衣(男)', '上元花灵衣(女)', '真-上元花灵衣(男)', '真-上元花灵衣(女)'],
        140: ['月舞花灵衣(男)', '月舞花灵衣(女)', '真-月舞花灵衣(男)', '真-月舞花灵衣(女)'],
        150: ['浩天花灵衣(男)', '浩天花灵衣(女)', '真-浩天花灵衣(男)', '真-浩天花灵衣(女)'],
      },
      10: {
        10: ['无名圣袍(男)', '无名圣袍(女)'],
        20: ['金丝圣袍(男)', '金丝圣袍(女)'],
        30: ['乌蚕圣袍(男)', '乌蚕圣袍(女)'],
        40: ['龙虎圣袍(男)', '龙虎圣袍(女)', '破天圣袍(男)', '破天圣袍(女)'],
        50: ['封神圣袍(男)', '封神圣袍(女)', '赤龙圣袍(男)', '赤龙圣袍(女)'],
        60: ['昊天圣袍(男)', '昊天圣袍(女)', '雪天圣袍(男)', ' 雪天圣袍(女)'],
        70: ['广寒圣袍(男)', '广寒圣袍(女)', '地藏圣袍(男)', '地藏圣袍(女)'],
        80: ['月神圣袍(男)', '月神圣袍(女)', '凝血圣袍(男)', '凝血圣袍(女)'],
        90: ['天灵圣袍(男)', '天灵圣袍(女)', '魔灵圣袍(男)', '魔灵圣袍(女)'],
        100: ['龙腾圣袍(男)', '龙腾圣袍(女)', '炎魔圣袍(男)', '炎魔圣袍(女)'],
        110: ['天授圣袍(男)', '天授圣袍(女)', '焚天圣袍(男)', '焚天圣袍(女)'],
        120: ['天尊圣袍(男)', '天尊圣袍(女)', '邪尊圣袍(男)', '邪尊圣袍(女)'],
        130: ['天元圣袍(男)', '天元圣袍(女)', '真-天元圣袍(男)', '真-天元圣袍(女)', '邪元圣袍(男)', '邪元圣袍(女)', '真-邪元圣袍(男)', '真-邪元圣袍(女)'],
        140: ['轩舞圣袍(男)', '轩舞圣袍(女)', '真-轩舞圣袍(男)', '真-轩舞圣袍(女)', '赤夜圣袍(男)', '赤夜圣袍(女)', '真-赤夜圣袍(男)', '真-赤夜圣袍(女)'],
        150: ['浩天圣袍(男)', '浩天圣袍(女)', '真-浩天圣袍(男)', '真-浩天圣袍(女)', '魔渊圣袍(男)', '魔渊圣袍(女)', '真-魔渊圣袍(男)', '真-魔渊圣袍(女)'],
      },
      11: {
        10: ['修炼武服（男）', '修炼武服（女）'],
        20: [''],
        30: ['初心武服（男）', '初心武服（女）'],
        40: [''],
        50: [''],
        60: ['飞龙武服（男）', '飞龙武服（女）'],
        70: [''],
        80: ['玄花武服（男）', '玄花武服（女）'],
        90: [''],
        100: ['飞舞武服（男）', '飞舞武服（女）'],
        110: ['水滴武服（男）', '水滴武服（女）'],
        120: ['花颜武服（男）', '花颜武服（女）'],
        130: ['万花武服（男）', '万花武服（女）', '真-万花武服（男）', '真-万花武服（女）'],
        140: ['玄武武服（男）', '玄武武服（女）', '真-玄武武服（男）', '真-玄武武服（女）'],
        150: ['浩天武袍（男）', '浩天武袍（女）', '真-浩天武袍（男）', '真-浩天武袍（女）'],
      },
      12: {
        10: ['金丝虎衣(男)'],
        20: [''],
        30: ['乌蚕虎衣(男)'],
        40: [''],
        50: [''],
        60: ['云天虎衣（男）'],
        70: [''],
        80: ['御风虎衣（男）'],
        90: [''],
        100: ['腾舞虎衣（男）'],
        110: ['擎天虎衣（男）'],
        120: ['玄尊虎衣（男）'],
        130: ['上元虎衣（男）', '真-上元虎衣（男）'],
        140: ['月舞虎衣（男）', '真-月舞虎衣（男）'],
        150: ['浩天虎袍（男）', '真-浩天虎袍（男）'],
      },
      13: {
        10: ['无名医袍（女）'],
        20: [''],
        30: ['乌蚕医袍（女）'],
        40: [''],
        50: [''],
        60: ['云天灵雀袍（女）'],
        70: [''],
        80: ['凝神灵雀袍（女）'],
        90: [''],
        100: ['腾舞灵雀服（女）'],
        110: ['擎天灵雀服（女）'],
        120: ['玄尊云雀袍（女）'],
        130: ['上元云雀袍（女）', '真-上元云雀袍（女）'],
        140: ['月舞云雀袍（女）', '真-月舞云雀袍（女）'],
        150: ['浩天云雀袍（女）', '真-浩天云雀袍（女）'],
      }
    },
    2:{
      0: {
        15: ['兽皮甲'],
        25: ['铁锁甲'],
        35: ['金丝甲', '金丝甲（梅柳真）'],
        45: ['软猬甲', '软猬甲（梅柳真）'],
        55: ['玄武战衣', '玄武战衣（梅柳真）'],
        65: [' 天蚕宝甲', '天蚕宝甲（梅柳真）'],
        75: ['裂魂玄甲', '裂魂玄甲（梅柳真）'],
        85: ['混元神甲', '混元神甲（梅柳真）'],
        95: ['乾坤鬼面甲', '乾坤鬼面甲（梅柳真）'],
        105: ['百灵战甲', '百灵战甲（梅柳真）'],
        115: ['炽烈精甲', '炽烈精甲（梅柳真）'],
        125: ['苍魇裂魂甲', '苍魇裂魂甲（梅柳真）'],
        135: ['天秀启贤甲', '天秀启贤甲（梅柳真）'],
        145: ['赤金吞云甲', '赤金吞云甲（梅柳真）'],
      }


    },
    3: {
      0: {
        60: ['磐龙耳环', '磐龙耳环(梅柳真)', '鬼眼灵珠'],
        80: ['青玉珠环', '青玉珠环(梅柳真)'],
        100: ['金魄珠环', '金魄珠环(梅柳真)', '血玉珠环', '血玉珠环(梅柳真)'],
        110: ['玉麟耳环'],
        115: ['血红耳环', '血红耳环(梅柳真)', '血红耳环-碎', '血红耳环-碎(梅柳真)'],
        120: ['狱魔耳环', '狱魔耳环(梅柳真)', '狱魔耳环-碎', '狱魔耳环-碎(梅柳真)'],
        130: ['傲天耳环', '傲天耳环(梅柳真)', '傲天耳环-碎', '傲天耳环-碎(梅柳真)'],
        140: ['星辰耳环', '星辰耳环(梅柳真)', '星辰耳环-碎', '星辰耳环-碎(梅柳真)'],
        150: ['绯蓝耳环-（魔）', '绯蓝耳环-（魔）(梅柳真)', '绯蓝耳环-（碎）', '绯蓝耳环-（碎）(梅柳真)'],
      },
      1: {
        60: ['元始指环', '元始指环(梅柳真)', '死灵之环'],
        80: ['潜能之戒', '潜能之戒(梅柳真)', '天战之戒', '天战之戒(梅柳真)'],
        100: ['墨灵环', '墨灵环(梅柳真)', '神力之环', '神力之环(梅柳真)'],
        110: ['玉麟戒指'],
        115: ['血红戒指', '血红戒指(梅柳真)', '血红戒指-碎', '血红戒指-碎(梅柳真)'],
        120: ['狱魔戒指', '狱魔戒指(梅柳真)', '狱魔戒指-碎', '狱魔戒指-碎(梅柳真)'],
        130: ['傲天戒指', '傲天戒指(梅柳真)', '傲天戒指-碎', '傲天戒指-碎(梅柳真)'],
        140: ['星辰戒指', '星辰戒指(梅柳真)', '星辰戒指-碎', '星辰戒指-碎(梅柳真)'],
        150: ['绯蓝戒指-（魔）', '绯蓝戒指-（魔）(梅柳真)', '绯蓝戒指-（碎）', '绯蓝戒指-（碎）(梅柳真)'],
      },
      2: {
        60: ['天神护符', '天神护符(梅柳真)', '浴血魔链'],
        80: ['至尊灵珠', '至尊灵珠(梅柳真)'],
        100: ['暗之链', '暗之链(梅柳真)', '影之链', '影之链(梅柳真)'],
        110: ['玉麟项链'],
        115: ['血红项链', '血红项链(梅柳真)'],
        120: ['狱魔项链', '狱魔项链(梅柳真)'],
        130: ['傲天项链', '傲天项链(梅柳真)'],
        140: ['星辰项链', '星辰项链(梅柳真)'],
        150: ['绯蓝项链-（魔）', '绯蓝项链-（魔）(梅柳真)', '绯蓝项链-（碎）', '绯蓝项链-（碎）(梅柳真)'],
      },


    }
  }
  return json[n][k][j]
}

